import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import {
  ICreditCard,
  initialAccountingCreditCardState,
} from "./CreditCard.types";
import { IDataTableV2DateState } from "../../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";

export const FETCH_ACCOUNTING_CREDIT_CARD_LIST_PROGRESS =
  "FETCH_ACCOUNTING_CREDIT_CARD_LIST_PROGRESS";
export const FETCH_ACCOUNTING_CREDIT_CARD_LIST_SUCCESS =
  "FETCH_ACCOUNTING_CREDIT_CARD_LIST_SUCCESS";
export const FETCH_ACCOUNTING_CREDIT_CARD_LIST_FAILURE =
  "FETCH_ACCOUNTING_CREDIT_CARD_LIST_FAILURE";

export const fetchAccountingCreditCardListProgress = () =>
  action(FETCH_ACCOUNTING_CREDIT_CARD_LIST_PROGRESS);

export const fetchAccountingCreditCardListSuccess = (
  data: ICreditCard[]
) => action(FETCH_ACCOUNTING_CREDIT_CARD_LIST_SUCCESS, { data });

export const fetchAccountingCreditCardListFailed = (errorMessage: string) =>
  action(FETCH_ACCOUNTING_CREDIT_CARD_LIST_FAILURE, { errorMessage });

export const fetchAccountingCreditCardListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchAccountingCreditCardListProgress());

      let finalUrl = `/accounting/get-accn-credit?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;
      if (searchValue.length > 0) {
        finalUrl = `/accounting/get-accn-credit?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${
          date.fromDate
        }&to_date=${date.toDate}&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }

      const res = await api.get(finalUrl);
      const data: ICreditCard[] = res.data.data;
      dispatch(fetchAccountingCreditCardListSuccess(data));
    } catch (err: any) {
      dispatch(
        fetchAccountingCreditCardListFailed("Something went to be wrong!")
      );
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const fetchAllAccountingCreditCardListAsync =
  (): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchAccountingCreditCardListProgress());

      const finalUrl = `/accounting/get-accn-credit?status=ACTIVE`;

      const res = await api.get(finalUrl);
      const data: ICreditCard[] = res.data.data;
      dispatch(fetchAccountingCreditCardListSuccess(data));
    } catch (err: any) {
      dispatch(
        fetchAccountingCreditCardListFailed("Something went to be wrong!")
      );
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

    export const FETCH_ACCOUNTING_CREDIT_CARD_PROGRESS =
  "FETCH_ACCOUNTING_CREDIT_CARD_PROGRESS";
export const FETCH_ACCOUNTING_CREDIT_CARD_SUCCESS =
  "FETCH_ACCOUNTING_CREDIT_CARD_SUCCESS";
export const FETCH_ACCOUNTING_CREDIT_CARD_FAILURE =
  "FETCH_ACCOUNTING_CREDIT_CARD_FAILURE";

export const fetchAccountingCreditCardProgress = () =>
  action(FETCH_ACCOUNTING_CREDIT_CARD_PROGRESS);

export const fetchAccountingCreditCardSuccess = (
  data: ICreditCard
) => action(FETCH_ACCOUNTING_CREDIT_CARD_SUCCESS, { data });

export const fetchAccountingCreditCardFailed = (errorMessage: string) =>
  action(FETCH_ACCOUNTING_CREDIT_CARD_FAILURE, { errorMessage });

export const fetchAccountingCreditCardAsync =
  (creditId: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchAccountingCreditCardProgress());

      const res = await api.get(
        `/accounting/get-accn-credit?column=credit_id&value=${creditId}`
      );
      const data: ICreditCard[] = res.data.data;
      if (data.length > 0) {
        dispatch(fetchAccountingCreditCardSuccess(data[0]));
      } else {
        dispatch(
          fetchAccountingCreditCardSuccess(
            initialAccountingCreditCardState["data"]
          )
        );
      }
    } catch (err: any) {
      dispatch(fetchAccountingCreditCardFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const addAccountingCreditCardAysnc =
  (
    data: ICreditCard,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      await api.post("/accounting/edit-accn-credit", {
        ...data,
      });
      const message = "Credit Card saved successfully.";
      dispatch(
        showMessage({
          type: "success",
          message: message,
          displayAs: "snackbar",
        })
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_ACCOUNTING_CREDIT_CARD = "CLEAR_ACCOUNTING_CREDIT_CARD";
export const clearAccountingCreditCard = () =>
  action(CLEAR_ACCOUNTING_CREDIT_CARD);
